import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const UpsellCoaching = lazyWithPreload(() => import('./UpsellCoaching'))
